import gql from 'graphql-tag';

const UPSERT_CAMPAIGN_ORDER_CRM_DATA = gql`
  mutation UpsertCampaignOrderCRMData(
    $campaignOrderId: String!
    $opportunity: JSON!
    $orgs: JSON
  ) {
    upsertCampaignOrderCRMData(
      campaignOrderId: $campaignOrderId
      opportunity: $opportunity
      orgs: $orgs
    )
  }
`;

export default UPSERT_CAMPAIGN_ORDER_CRM_DATA;
